import I18n from "components/materials/I18n";
import { EProjectTab, useProjectFormTab } from "../../ProjectFormContext";
import classes from "./classes.module.scss";
import MenuItem from "./MenuItem";
import { InformationCircleIcon, InboxIcon, StarIcon, PhotoIcon, UserGroupIcon, ClockIcon, EnvelopeOpenIcon } from "@heroicons/react/20/solid";
import classNames from "classnames";
import MenuItemWithSubtabs from "./MenuItemWithSubTabs";

export type TMenuItem = {
	icon: JSX.Element;
	label: string;
	tab: EProjectTab;
	subTabs?: Pick<TMenuItem, "tab" | "label">[];
};

type IProps = {
	className?: string;
};

const getMenuItems: () => TMenuItem[] = () => [
	{
		icon: <InformationCircleIcon className={classes["icon"]} />,
		label: I18n.asset.pages.professional_space.tabs.information.title,
		tab: EProjectTab.INFORMATION,
		subTabs: [
			{ label: I18n.asset.pages.professional_space.tabs.information.sub_tabs.content, tab: EProjectTab.INFORMATION_CONTENT },
			{ label: I18n.asset.pages.professional_space.tabs.information.sub_tabs.project_leader, tab: EProjectTab.INFORMATION_PROJECT_LEADER },
			{ label: I18n.asset.pages.professional_space.tabs.information.sub_tabs.documents, tab: EProjectTab.INFORMATION_DOCUMENTS },
			{ label: I18n.asset.pages.professional_space.tabs.information.sub_tabs.contact_and_socials, tab: EProjectTab.INFORMATION_CONTACT_AND_SOCIALS },
		],
	},
	{
		icon: <EnvelopeOpenIcon className={classes["icon"]} />,
		label: I18n.asset.pages.professional_space.tabs.votes.title,
		tab: EProjectTab.VOTES,
	},
	{
		icon: <ClockIcon className={classes["icon"]} />,
		label: I18n.asset.pages.professional_space.tabs.actions.title,
		tab: EProjectTab.ACTIONS,
	},
	{
		icon: <InboxIcon className={classes["icon"]} />,
		label: I18n.asset.pages.professional_space.tabs.forum.title,
		tab: EProjectTab.FORUM,
	},
	{
		icon: <StarIcon className={classes["icon"]} />,
		label: I18n.asset.pages.professional_space.tabs.casting.title,
		tab: EProjectTab.CASTING,
	},
	{
		icon: <PhotoIcon className={classes["icon"]} />,
		label: I18n.asset.pages.professional_space.tabs.media.title,
		tab: EProjectTab.MEDIA,
	},
	{
		icon: <UserGroupIcon className={classes["icon"]} />,
		label: I18n.asset.pages.professional_space.tabs.team.title,
		tab: EProjectTab.TEAM,
	},
];

export default function ProfessionalSpaceNavMenu(props: IProps) {
	const { currentTab, setCurrentTab, isTabEnabled } = useProjectFormTab();

	return (
		<div className={classNames(classes["root"], props.className)}>
			{getMenuItems().map((item, index) =>
				item.subTabs ? (
					<MenuItemWithSubtabs key={index} menuItem={item} setCurrentTab={setCurrentTab} currentTab={currentTab} />
				) : (
					<MenuItem key={index} menuItem={item} onClick={() => setCurrentTab(item.tab)} active={currentTab === item.tab} disabled={!isTabEnabled(item.tab)} />
				),
			)}
		</div>
	);
}
